import { render, staticRenderFns } from "./TableMuestra.vue?vue&type=template&id=9171c1b4&"
import script from "./TableMuestra.vue?vue&type=script&lang=ts&"
export * from "./TableMuestra.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports